export default function generateBotEmbedCode({ tenantId, botId, title, logoUrl, css, botServiceURL }) {
  return `
<!-- c7o.ai bot widget begin -->
<link href="https://unpkg.com/@enegelai/bot-widget/dist/enegelaibot.css" rel="stylesheet">
<script src="https://unpkg.com/@enegelai/bot-widget/dist/enegelaibot.umd.js" type="text/javascript" async></script>

<style>
${css}
</style>

<script>
    (function() {
        var el = document.createElement('enegelai-bot');
        el.setAttribute('name', '${title}');
        el.setAttribute('url', '${botServiceURL}');
        el.setAttribute('org-id', '${tenantId}');
        el.setAttribute('bot-id', '${botId}');
        el.setAttribute('logo-url', '${logoUrl}');
        document.body.appendChild(el);
    })();
</script>
<!-- c7o.ai bot widget end -->
  `;
}
